// Branding configuration from environment variables
export const getBranding = () => ({
  // App name - shown in browser tab
  appName: process.env.REACT_APP_NAME || process.env.REACT_APP_BRAND_NAME || 'Checkout Pro',
  
  // Brand/Company name for footer
  brandName: process.env.REACT_APP_BRAND_NAME || 'YourCompany Inc.',
  
  // Footer configuration
  footerText: process.env.REACT_APP_FOOTER_TEXT || `© ${new Date().getFullYear()} YourCompany Inc. All rights reserved.`,

  // Currency and localization
  currency: {
    code: process.env.REACT_APP_CURRENCY_CODE || 'PHP',
    symbol: process.env.REACT_APP_CURRENCY_SYMBOL || '₱',
    locale: process.env.REACT_APP_CURRENCY_LOCALE || 'en-PH',
  },
  
  // Country and order configuration
  countryCode: process.env.REACT_APP_COUNTRY_CODE || 'PH',
  orderIdPrefix: process.env.REACT_APP_ORDER_ID_PREFIX || 'ORD',
});